const  Settings = {
  author: 'Origin',
  name: 'Origin',
  cookies: {
    lang: 'origin_lang',
  },
  locale: ['fr', 'en'],
  loader: true,
  mode: 'out-in',
  prefixRoute: false,
  cms: false,
}

// dev
if((process.env.NODE_ENV !== 'production'))
  Settings['BASE_URL'] = 'https://eat-the-internet.dpt.media' 
// production
else
  Settings['BASE_URL'] = ''

// concat BASE_URL + PREFIX
// Settings['API_URL'] = Settings.BASE_URL + '/' + Settings.API_PREFIX + '/'

Settings['API_URL'] = Settings.BASE_URL + '/' 
module.exports = Settings
